import React, { FC } from "react";
import { Link } from "react-router-dom";
import { FullPageChatLinkProps } from "@zeemee/react-web-chat";
import { useRoute } from "@/routes/getRoute";

export const FullPageChatLink: FC<FullPageChatLinkProps> = ({
  children,
  selectedChat,
  ...props
}) => {
  const getRoute = useRoute();
  return (
    <Link
      {...props}
      to={
        selectedChat
          ? getRoute("selectedChat", { chat: selectedChat })
          : getRoute("chat")
      }
    >
      {children}
    </Link>
  );
};
